import React from "react";
import { motion } from "framer-motion";
import "../App.css";
import "../csscontainer/AboutUs.css";
import { TEXT } from "../utility/constants";
import Footer from "../components/Footer";
import Text from "../components/Text.js";
import DynamicText from "../components/Text";
import BulletList from "../components/BulletList.js";
import aboutUs from "../assets/images/about_us.png"; // Adjust the path as necessary

const coverageData = [
  {
    tier: "Basic (8x5)",
    coverage: "8x5",
    description:
      "Business Hours Coverage from 9am–6pm, Monday to Friday, excluding Public Holidays.",
    idealFor:
      "Standard IT needs where issues can be addressed during typical business hours.",
  },
  {
    tier: "Premium (24x7)",
    coverage: "24x7",
    description: "Continuous support available 24x7, 365 days a year.",
    idealFor:
      "Mission-critical operations requiring immediate attention regardless of the time or day.",
  },
  {
    tier: "OnSite Support (24x7)",
    coverage: "24x7",
    description:
      "On-site support also available in all major regions for hands-on physical intervention.",
    idealFor:
      "Infrastructure or maintenance tasks that require hands-on physical intervention at your location.",
  },
];

const ABOUT_US_PILLARS_BULLETS = [
  TEXT.aboutbullet1,
  TEXT.aboutbullet2,
  TEXT.aboutbullet3,
  TEXT.aboutbullet4,
  TEXT.aboutbullet5,
];
function AboutUs() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        {/* --- NEW SECTION FOR IMAGE ON RIGHT AND TEXT ON LEFT --- */}
        <div className="service-intro-section">
          <div className="service-intro-text">
            <Text
              color="#2C1F5CFF"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.aboutTitle}
            </Text>
            <Text
              color="#494D4DFF"
              size="22px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.aboutSub}
            </Text>
            <Text
              color="#364040FF"
              size="18px"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.aboutDesc}
            </Text>
          </div>
          <div className="service-intro-image">
            <img
              src={aboutUs} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
        </div>

        <div>
          <DynamicText
            as="h1"
            color="#3A3434FF"
            size="2rem"
            align="center"
            fontStyle="bold"
          >
            {TEXT.aboutTitle2}
          </DynamicText>
          <DynamicText
            as="h1"
            color="#3A3434FF"
            size="1.3rem"
            align="center"
            fontStyle="normal"
            extraStyles={{ marginTop: "10px", marginBottom: "20px" }}
          >
            {TEXT.aboutDesc2}
          </DynamicText>

          <DynamicText
            as="h1"
            color="#3A3434FF"
            size="1.8rem"
            align="center"
            fontStyle="normal"
            extraStyles={{ marginTop: "10px", marginBottom: "20px" }}
          >
            {TEXT.aboutHeading}
          </DynamicText>
        </div>

        <div className="custom-container">
          <BulletList points={ABOUT_US_PILLARS_BULLETS} />
        </div>
        <div className="coverage-table-container">
          <h3>Service Coverage You Can Rely On</h3>
          <table className="coverage-table">
            <thead>
              <tr>
                <th>Coverage Type</th>
                <th>Availability</th>
                <th>Description</th>
                <th>Ideal For</th> {/* NEW COLUMN HEADER */}
              </tr>
            </thead>
            <tbody>
              {coverageData.map((item, index) => (
                <tr key={index}>
                  <td data-label="Coverage Type" className="tier-name">
                    {item.tier}
                  </td>
                  <td data-label="Availability" className="tier-coverage">
                    {item.coverage}
                  </td>
                  <td data-label="Description" className="tier-description">
                    {item.description}
                  </td>
                  <td data-label="Ideal For" className="tier-ideal-for">
                    {item.idealFor}
                  </td>{" "}
                  {/* NEW DATA CELL */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Footer />
      </div>
    </motion.div>
  );
}

export default AboutUs;
